module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"
  }), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--8-col mdl-cell--8-col-tablet"
  }, [_c('div', {
    staticClass: "profile mdl-grid"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--12-col"
  }, [_c('header', {
    staticClass: "profile__header"
  }, [_c('img', {
    attrs: {
      "src": _vm.$user.data.avatar,
      "alt": "Imagen de Perfil del Usuario"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "profile__header-title"
  }, [_vm._v(_vm._s(_vm.$user.data.name))]), _vm._v(" "), _c('div', {
    staticClass: "profile__header-subtitle"
  }, [_c('span', [_vm._v(_vm._s(_vm.$user.data.role.toUpperCase()))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$user.data.email))])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col"
  }, [_c('main', {
    staticClass: "profile__content"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col"
  }, [_c('footer', {
    staticClass: "profile__footer"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f37cb4d6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Profile/index.vue
// module id = 258
// module chunks = 0